<template>
  <div class="bootcamp-testimonials">
    <h3 class="section-subtitle">JOIN THOUSANDS OF GAMERS IMPROVING</h3>
    <h2 class="section-title">Hear why students love ProGuides</h2>
    <div class="testimonials">
      <BootcampTestimonial
        v-for="(testimonial, index) in testimonials"
        :key="testimonial.title"
        :testimonial="testimonial"
        :index="index"
      />
    </div>
    <span
      class="see-more"
      @click="showMore"
      v-if="onSmallScreen && !showingMore"
      >SEE MORE</span
    >
    <span class="see-more" @click="showMore" v-if="onSmallScreen && showingMore"
      >SEE Less</span
    >
  </div>
</template>

<script>
import BootcampTestimonial from "@/components/bootcamp/enroll/testimonial/BootcampTestimonial.vue"
import { TESTIMONIALS_V3 } from "@/constants/testimonials"
export default {
  components: {
    BootcampTestimonial,
  },
  data: function () {
    return {
      TESTIMONIALS_V3: TESTIMONIALS_V3,
      showingMore: false,
    }
  },
  computed: {
    onSmallScreen () {
      return ["sm", "xs"].includes(this.$mq)
    },
    testimonials () {
      if (this.onSmallScreen) {
        if (!this.showingMore) {
          return TESTIMONIALS_V3.slice(0, 3)
        }
        return TESTIMONIALS_V3
      }
      if (["md", "lg"].includes(this.$mq)) {
        return TESTIMONIALS_V3.slice(0, 8)
      }
      return TESTIMONIALS_V3
    },
  },
  methods: {
    showMore () {
      this.showingMore = !this.showingMore
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.bootcamp-testimonials {
  padding-bottom: 7.4rem;
  padding-top: 8.4rem;
  @include tablet-down {
    padding-bottom: 4rem;
    padding-top: 4rem;
  }
  .testimonials {
    margin: 0 auto;
    width: 120.1rem;
    columns: 3;
    column-gap: 2rem;
    @include desktop-down {
      columns: 2;
      width: 79.4rem;
    }
    @include phone-down {
      columns: unset;
      column-gap: unset;
      width: 95%;
    }
  }
  .see-more {
    display: none;
    @include phone-down {
      display: block;
      color: #f42556;
      font-weight: 500;
      font-size: 1rem;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/testimonial/TheBootcampTestimonials.vue